import styled from 'styled-components';
import { MoreHorizontalRegular } from '@fluentui/react-icons';

export const MoreHorizontalIcon = styled(MoreHorizontalRegular)`
  width: 20px;
  height: 20px;

  :focus {
    outline: none;
  }
`;
